import { render } from "./LeaveForm.vue?vue&type=template&id=6f1a4bd0&scoped=true"
import script from "./LeaveForm.vue?vue&type=script&lang=js"
export * from "./LeaveForm.vue?vue&type=script&lang=js"

import "./LeaveForm.vue?vue&type=style&index=0&id=6f1a4bd0&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1a4bd0"]])

export default __exports__